// extracted by mini-css-extract-plugin
export default {"project_editor_block":"ProjectEditorBody_project_editor_block__9IFhe","project_editor_action_container":"ProjectEditorBody_project_editor_action_container__U1UoW"};